import { pageTitleStyles } from "@WhiteCap/Overrides/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h2",
    css: css`
        font-size: 24px;
        line-height: 30px;
    `,
};
